import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { connect } from 'react-redux';

import Routes from './routes';
import HeaderBar from './containers/HeaderBar';
import Footer from './components/Footer';
import { setIsAuthenticated, logout } from './redux/actions/user';

import styles from './App.module.less';

class App extends Component {
  static propTypes = {
    user: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    isAuthenticating: PropTypes.bool,
    setIsAuthenticated: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired
  };

  userHasAuthenticated = authenticated => {
    this.props.setIsAuthenticated(authenticated);
  };

  render() {
    const childProps = {
      isAuthenticated: this.props.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated
    };

    return (
      !this.props.isAuthenticating && (
        <div className={classNames(styles.app, 'container-fluid')}>
          <HeaderBar />
          <Routes childProps={childProps} />
          <Footer />
        </div>
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.user.isAuthenticated,
    isAuthenticating: state.user.isAuthenticating
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setIsAuthenticated: authenticated =>
      dispatch(setIsAuthenticated(authenticated)),
    logout: () => dispatch(logout())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js